import axios from "axios";

import { API_BASE_URL } from "../constants";

export default class ConfluenceService {
    static instance;
    resource = `${API_BASE_URL}/confluence_setting`;

    constructor() { }

    static getInstance() {
        if (!ConfluenceService.instance) {
            ConfluenceService.instance = new ConfluenceService();
        }

        return ConfluenceService.instance;
    }

    async fetchSettings() {
        const response = await axios.get(`${this.resource}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        
        return response.data.data;
    }

    async saveSettings(settings) {
        const response = await axios.post(`${this.resource}/edit`, settings, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    }

    async toggleActivation(isActive) {
        const response = await axios.post(
            `${this.resource}/toggle_active`,
            { isActive },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    }

    async testConnection(payload) {
        const response = await axios.post(
            `${this.resource}/validate`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
        
        return response.data;
    }
}
